import { render, staticRenderFns } from "./speaker-icon.svg.vue?vue&type=template&id=0a5399be&"
import script from "./speaker-icon.svg.vue?vue&type=script&lang=js&"
export * from "./speaker-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports